module.exports = __webpack_public_path__ + "img/file.25e4b25a.svg";